import { SagaIterator } from 'redux-saga';
import { all, fork } from 'redux-saga/effects';
import { rootSaga as homeSubApplicationSaga } from './home/root-saga';
import { rootSaga as singleDevCenterSubApplicationSaga } from './single-dev-center/root-saga';

export function* rootSaga(): SagaIterator {
    yield all([fork(homeSubApplicationSaga), fork(singleDevCenterSubApplicationSaga)]);
}
